import { render, staticRenderFns } from "./LongTextBubble.vue?vue&type=template&id=185c3bfc&scoped=true"
import script from "./LongTextBubble.vue?vue&type=script&lang=js"
export * from "./LongTextBubble.vue?vue&type=script&lang=js"
import style0 from "./LongTextBubble.vue?vue&type=style&index=0&id=185c3bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c3bfc",
  null
  
)

export default component.exports